<div class="flex space-between bottom-spacer actions">
  <div class="heading-2 bold">{{ heading }}</div>
  <div *ngIf="!utilService.isMobile">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
</div>
<hr class="slim" *ngIf="isView">
<div class="flex flex-grow" *ngIf="isView">
  <div class="flex flex-column">
    <app-label-value [label]="'general.api_users_form_first_name'" [value]="user.firstName"></app-label-value>
    <app-label-value [label]="'general.api_users_form_email'" [value]="user.email"></app-label-value>
  </div>
  <div class="flex flex-column">
    <app-label-value [label]="'general.api_users_form_last_name'" [value]="user.lastName"></app-label-value>
    <app-label-value [label]="'general.api_users_form_phone'" [value]="user.phoneNr"></app-label-value>
    <app-label-value [label]="'general.api_users_form_status_code'" [value]="('general.api_users_status_code_' + userStatus).toLowerCase()"></app-label-value>
  </div>
</div>
<div class="flex" [ngClass]="{'flex-column': utilService.isMobile }">
  <hr class="slim" *ngIf="isView">
  <ng-container *ngIf="!isView">
    <app-text-input class="max-width" [appClass]="'responsive-input'" [label]="'general.api_users_form_first_name'" [name]="'firstName'"
                    [(value)]="user.firstName" [required]="true" [min]="2"></app-text-input>
    <app-text-input class="max-width" [appClass]="'responsive-input'" [label]="'general.api_users_form_last_name'" [name]="'lastName'"
                    [(value)]="user.lastName" [required]="true" [min]="2"></app-text-input>
    <app-phone-input class="max-width" [ngClass]="{'responsive-input': !utilService.isMobile && !isMyProfile}"
                     [label]="'general.api_users_form_phone'" [(phoneNr)]="user.phoneNr"></app-phone-input>
    <app-text-input class="max-width" [appClass]="'responsive-input'" [label]="'general.api_users_form_email'" [name]="'email'"
                    [(value)]="user.email" [required]="true" [type]="TextInputType.Email"></app-text-input>
  </ng-container>
  <mat-form-field appearance="outline" class="max-width responsive-input no-hint" *ngIf="isEdit && !isMyProfile">
    <mat-label>{{'general.api_users_form_status_code' | translate}}</mat-label>
    <mat-select name="statusCode"
                [(ngModel)]="userStatus" (selectionChange)="userStatusChange.emit($event.value)" [ngModelOptions]="{standalone: true}" [disabled]="!canChangeStatusCode">
      <mat-select-trigger>{{('general.api_users_status_code_' + userStatus).toLowerCase() | translate}}</mat-select-trigger>
      <mat-option *ngFor="let statusCode of statusCodes" [value]="statusCode.name" [disabled]="statusCode.disabled">
        {{('general.api_users_status_code_' + statusCode.name).toLowerCase() | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="notification-block top-spacer-x2" *ngIf="user.pendingEmail">
  <div class="notification-header">
    <div class="heading-5 bold">
      {{ 'general.api_users_form_new_email' | translate }}
      <span class="text-grey tooltip" [matTooltip]="('general.api_users_form_new_email_tooltip' | translate)">
        <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
      </span>
    </div>
  </div>
  <div class="flex space-between">
    <div class="notification-content">
      <span class="display-inline-block right-spacer">{{ user.pendingEmail }}</span>
      <span class="badge accent">{{ 'general.api_users_form_new_email_pending' | translate }}</span>
    </div>
    <div class="notification-actions">
      <a class="link" (click)="resendEmailConfirmation()">
        <mat-icon class="svg-icon" [svgIcon]="'e_mail_resend'"></mat-icon>
        <span>{{ 'general.api_users_form_new_email_resend_confirmation' | translate }}</span>
      </a>
    </div>
  </div>
</div>
<footer *ngIf="utilService.isMobile && !isView">
  <div class="mat-mdc-dialog-actions">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
</footer>

<ng-template #actionButtons>
  <button mat-stroked-button color="primary" (click)="confirmClearSessions()" *ngIf="isClearSessionAllowed">
    <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
    {{ 'general.api_users_form_clear_sessions' | translate }}
  </button>
  <button mat-stroked-button color="primary" (click)="resetPassword()" *ngIf="isEdit && !isMyProfile">
    <mat-icon class="svg-icon" [svgIcon]="'password_change'"></mat-icon>
    {{ 'general.api_users_form_reset_password' | translate }}
  </button>

  <button mat-flat-button color="primary" *ngIf="isCreate" (click)="create.emit()" [disabled]="!userService.isValid(user)">
    {{ 'general.api_users_form_create' | translate }}
  </button>
  <button mat-flat-button color="primary" *ngIf="isEdit" class="grow-3" (click)="update.emit()" [disabled]="!userService.isValid(user)">
    {{ 'general.api_users_form_save' | translate }}
  </button>
</ng-template>
